import { Component, OnInit } from '@angular/core';
import { BenchmarkService } from './benchmarks.service';
import { ColumnChartComponent } from '../zoomView/column-chart/column-chart.component';
import { ModalService } from '../../../services/modalService/modal.service';
import { LoginService } from '../../../services/login.service';
import { ActivatedRoute } from '@angular/router';
import { MigrationNoticeModalComponent } from '../../../custom-modals/migration-notice-modal.component';
import { ModalHelper } from '../../../services/modalService/modal.helper';
import { TranslateService } from '@ngx-translate/core';
import { BackendTranslateService } from '../../../helper/backend-translate.service';

@Component({
  selector: 'app-benchmark-average',
  templateUrl: './allBenchmarks.html',
  styleUrls: ['../myreports.component.css', './benchmarks.component.css']
})
export class AverageComponent implements OnInit {
  chartDataKey = 'averageSessionBenchmark';
  columnChartData: any = [];
  title = this.translate.instant('reports.benchmark.avgSessionDuration');
  options: any = {
    titlePosition: 'out',
    chartArea: { top: 30 },
    legend: { position: 'none' },
    intervals: {
      barWidth: 0.25,
      boxWidth: 1,
      lineWidth: 2,
      style: 'bars'
    },
    interval: {
      max: {
        style: 'bars',
        fillOpacity: 1,
        color: 'black'
      },
      min: {
        style: 'bars',
        fillOpacity: 1,
        color: 'black'
      }
    },
    vAxis: { minValue: 0 }
  };
  chartError = false;

  currentUser: any;
  public isLoggedIn = false;
  ruid: string;
  feature: string = undefined;
  features: any = [];
  descriptions: any = [];

  constructor(private benchmarkService: BenchmarkService,
    private modalHelper: ModalHelper,
    private modalService: ModalService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    protected translate: TranslateService,
    private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
    this.benchmarkService.getBenchmarks().subscribe((data: any) => {
     if(data[this.chartDataKey]){
     
       let report = JSON.parse(JSON.stringify(data[this.chartDataKey])); 
       //console.log(report)
       for(let key of Object.keys(report)) {
            report[key][0][0].label = this.backendTranslate.translateMessage(report[key][0][0].label);
            report[key][0][1].label = this.backendTranslate.translateMessage(report[key][0][1].label);
            report[key].forEach((el, i) => {
              if(i !== 0) {
                report[key][i][0] = this.backendTranslate.translateMessage(el[0]);
              }
            });
          }
          //console.log(report)
          this.columnChartData = report;
     }
      // if(data[this.chartDataKey] && data[this.chartDataKey].length > 0){
        // let report = JSON.parse(JSON.stringify(data[this.chartDataKey])); 
        // console.log(this.columnChartData);
        // if(report) { 
        //   console.log(report)
        //   for(let key of Object.keys(report)) {
        //     report[key][0][0].label = this.backendTranslate.translateMessage(report[key][0][0].label);
        //     report[key][0][1].label = this.backendTranslate.translateMessage(report[key][0][1].label);
        //     report[key].forEach((el, i) => {
        //       if(i !== 0) {
        //         report[key][i][0] = this.backendTranslate.translateMessage(el[0]);
        //       }
        //     });
        //   }
        // } 

        
        // console.log(this.columnChartData); 
          // this.columnChartData.forEach((element, index) => {
          //   this.columnChartData[index][0][0].label = this.backendTranslate.translateMessage(this.columnChartData[index][0][0].label);
          //   this.columnChartData[index][0][1].label = this.backendTranslate.translateMessage(this.columnChartData[index][0][0].label);
          //   element.forEach((el, i) => {
          //     if(i !== 0) {
          //       this.columnChartData[index][i][0] = this.backendTranslate.translateMessage(el);
          //     }
          //   });
          // });
        // }
      // }

      // console.log(this.columnChartData);
     

      this.features = data.features;
      this.descriptions = data.featureDescriptions;
      if (!this.feature && this.features) {
        this.feature = this.features[0];
      }
    });
    
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
      }

      this.loginService.isLoggedIn()
        .subscribe((isLoggedIn) => {
          this.currentUser = isLoggedIn;
          this.isLoggedIn = this.currentUser.isLoggedIn;
        });
    });
  }

  zoomView() {
    this.modalService.open(
      ColumnChartComponent,
      { data: this }
    ).subscribe(model => {
    });
  }


  public loginPrompt() {
    this.modalHelper.openLogin({});
  }

  public createAccount() {
    this.modalService.open(MigrationNoticeModalComponent, {
      title: this.translate.instant('account.migrationNotice.title'),
      data: {
        message: this.translate.instant('account.migrationNotice.message'),
        registerText: this.translate.instant('account.migrationNotice.registerText'),
        registerLinkText: this.translate.instant('account.migrationNotice.registerLinkText'),
        loginText: this.translate.instant('account.migrationNotice.loginText'),
        loginLinkText: this.translate.instant('account.migrationNotice.loginLinkText')
      }
    });
  }
}

@Component({
  selector: 'app-denial-frequency',
  templateUrl: './allBenchmarks.html',
  styleUrls: ['../myreports.component.css', './benchmarks.component.css']
})
export class DenialFrequencyComponent extends AverageComponent {

  chartDataKey = 'denialFrequencyBenchmark';
  title = this.translate.instant('reports.benchmark.denialPerHours');
}

@Component({
  selector: 'app-license-active-user',
  templateUrl: './allBenchmarks.html',
  styleUrls: ['../myreports.component.css', './benchmarks.component.css']
})
export class LicenseUserComponent extends AverageComponent {
  chartDataKey = 'licensesPerActiveUsersBenchmark';
  title = this.translate.instant('reports.benchmark.noLicense');
}

@Component({
  selector: 'app-percent-usage',
  templateUrl: './allBenchmarks.html',
  styleUrls: ['../myreports.component.css', './benchmarks.component.css']
})
export class PercentUsageComponent extends AverageComponent implements OnInit {
  chartDataKey = 'percentUsageBenchmark';
  title = this.translate.instant('reports.benchmark.total');
}

@Component({
  selector: 'app-user-session',
  templateUrl: './allBenchmarks.html',
  styleUrls: ['../myreports.component.css', './benchmarks.component.css']
})
export class UserSessionComponent extends AverageComponent implements OnInit {
  chartDataKey = 'userSessionsBenchmark';
  title = this.translate.instant('reports.benchmark.daily');
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/benchmarks/all.benchmarks.component.ts